import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShPaginationService } from '../../http/services/pagination.service';
import { OrganisationId } from '../../organisations/entities/organisation.entity';
import { Domain } from '../entities/domain.entity';

@Injectable({ providedIn: 'root' })
export class DomainsDataService {
    protected readonly ENDPOINT: string = `v2/domains`;

    // Injectors
    protected paginationService: ShPaginationService = inject(ShPaginationService);

    public getPublicOrganisationDomain(organisationId: OrganisationId): Observable<string> {
        const params: HttpParams = new HttpParams().append('organisationId', organisationId);

        return this.paginationService
            .getAll<Domain>(this.ENDPOINT, params)
            .pipe(map(domains => this.publicDomainUrl(domains)));
    }

    private publicDomainUrl(domains: Domain[]): string {
        const publiclyAccessibleDomains = domains.filter(domain => domain.PubliclyAccessible);

        if (!publiclyAccessibleDomains.length) {
            throw new Error('No publicly accessible domains configured for this organisation');
        }

        if (publiclyAccessibleDomains.length === 1) {
            return publiclyAccessibleDomains[0].Uri;
        }

        // Multiple public domains configured - check for a match with current URL
        //  use `hostname` = no port, not `host`, since domain is URI, no port
        const matchingDomain = publiclyAccessibleDomains.find(domain => domain.Uri === this.getHostName());

        if (matchingDomain) {
            return matchingDomain.Uri;
        }

        // current URL not having any matching public accessible domain - show error since will cause CSP error
        throw new Error('Multiple publicly accessible domains configured but none match current URL');
    }

    private getHostName(): string {
        return window.location.hostname;
    }
}
